export default __webpack_public_path__ + "static/media/Ellipse.2bd4e99f.webp";